import { schema, defaultValuesSchema } from "./schema";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import reqEmpresa from "../../../../services/reqMultiTenant/reqEmpresa";
import { useContext, useEffect, useState } from "react";
import { ContextGlobal } from "../../../../context";
import Notification, { handleMessageWarning } from "../../../../components/toast";
import { onlyNumbers, splitText } from "../../../../util/libString";
import reqClientAsaas from "../../../../services/reqAsaas/reqClient";
import { ContextContracting } from "../../context";
import { useAddress } from "../../../../hook/useAddress";

export const IndexHook = () => {
	//implemente o hook navigate

	const {
		register,
		handleSubmit,
		setValue,
		setFocus,
		getValues,
		setError,
		reset,
		watch,
		control,
		formState: { errors, isSubmitting },
	} = useForm({
		mode: "all",
		resolver: zodResolver(schema),
		defaultValues: defaultValuesSchema,
	});

	// const { fetchCities, citiesData } = useContext(ContextGlobal);
	const { brazilStates, fetchCitiesByUf, loadingCities } = useContext(ContextGlobal);
	const { custumerAsaas, setCustumerAsaas, setLoading, loading, setStage } = useContext(ContextContracting);

	const [citiesData, setCitiesData] = useState([]);

	//#region Fetch Empresa Data

	const getReturnUpdated = (response) => {
		if (Array.isArray(response.data)) {
			return response.data[0];
		} else if (typeof response.data === "object") {
			return response.data;
		} else {
			throw new Error("Formato do retorno inválido.");
		}
	};

	const fetchEmpresaData = async () => {
		try {
			setLoading(true);
			const response = await reqEmpresa.listID();
			const storeData = getReturnUpdated(response);

			const ativoValue = storeData.ativo === "SIM"; // Converte "SIM" para true, "NAO" para false
			storeData.ativo = ativoValue;

			Object.keys(storeData).forEach((field) => {
				setValue(field, storeData[field]);
			});

			await handleFetchCitiesByUf(storeData.uf);
		} catch (error) {
			handleMessageWarning(error.message);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchEmpresaData(); // Chama a função de busca de dados
	}, []); //

	//#endregion

	//#region Buscar Cidades pelo estado
	const handleFetchCitiesByUf = async (uf) => {
		try {
			const responseCities = await fetchCitiesByUf(uf); // Aqui vai a função para buscar as cidades

			setCitiesData(responseCities);
		} catch (error) {
			handleMessageWarning(error.message);
		}
	};
	//#endregion

	// useEffect(() => {
	// 	fetchCities();
	// 	fetchID();
	// }, []);

	// const fetchID = async () => {
	// 	try {
	// 		setLoading(true);

	// 		await fetchCities();
	// 		// if (id_cliente > 0) {
	// 		const response = await reqEmpresa.listID();

	// 		const returnData = getReturnUpdated(response);

	// 		if (returnData.cep === null) returnData.cep = "";
	// 		Object.keys(returnData).forEach((field) => {
	// 			setValue(field, returnData[field]);
	// 			// Reset the form with the fetched data
	// 			reset(returnData);
	// 		});
	// 	} catch (error) {
	// 		Notification.showToast({
	// 			message: error.message,
	// 			type: "warning",
	// 		});
	// 		handleCloseModalRegister();
	// 	} finally {
	// 		setLoading(false);
	// 	}
	// };

	// //#region Buscar Cidades pelo estado
	// const handleFetchCitiesByUf = async (uf) => {
	// 	try {
	// 		const responseCities = await fetchCitiesByUf(uf); // Aqui vai a função para buscar as cidades

	// 		setCitiesData(responseCities);
	// 	} catch (error) {
	// 		handleMessageWarning(error.message);
	// 	}
	// };
	// //#endregion

	//#region Selecionar estado e buscar as cidades

	const handleSelectedState = async (selectedOption) => {
		// quando selecionar o estado no input chama essa função
		await handleFetchCitiesByUf(selectedOption.value);
		setValue("id_cidade", "");
	};
	//#endregion

	//#region Pesquisar e preenche o endereço pelo cep
	const { handleFetchAddressByCep, cepIsSubmitting } = useAddress(setValue, setFocus, getValues);

	const handleFetchAddress = async () => {
		try {
			const uf = await handleFetchAddressByCep();
			handleFetchCitiesByUf(uf);
		} catch (error) {
			handleMessageWarning(error.message);
		}
	};
	//#endregion

	const errosAfterPost = (field, message) => {
		if (field === "CPF/CNPJ") field = "CPF";

		setError(field?.toLowerCase(), { type: "manual", message: message });
	};

	const handleOnSubmit = async (data) => {
		try {
			const responseInsert = await reqEmpresa.patch(data);
			//todo verificar se o cliente alterou alguma informação no cadastro pq ai tem que atualizar o asaas
			const dataClient = createBodyClient(data);

			const responseAsaas = await reqClientAsaas.insert(dataClient);

			if (responseAsaas?.data && typeof responseAsaas.data === "object") {
				setCustumerAsaas(responseAsaas?.data?.id_cliente_asaas);
			} else setCustumerAsaas(null);

			Notification.showToast({
				message: "Registro salvo com sucesso.",
				type: "success",
			});

			setStage(2);
			// reset();

			// navigate("/download");
		} catch (error) {
			if (error.field) errosAfterPost(error.field, error.message);
			Notification.showToast({
				message: error.message,
				type: "warning",
			});
		}
	};

	const createBodyClient = (data) => {
		const [rua, numero] = splitText(data.rua, ",");

		return {
			ambiente: 1,
			name: data.nome,
			cpfCnpj: data.cpf,
			email: data.email,
			mobilePhone: onlyNumbers(data.telefone_1),
			address: rua,
			addressNumber: data.numero,
			complement: "",
			province: data.cidade,
			postalCode: onlyNumbers(data.cep),
			externalReference: data.id_empresa,
			notificationDisabled: true,
			municipalInscription: "",
			stateInscription: "",
			observations: "",
			groupName: "SZ_PDV",
			company: "SZSISTEMAS",
		};
	};

	const handleCloseModalRegister = () => {
		const event = new CustomEvent(`StoreConfirmation`);
		window.dispatchEvent(event);
	};

	return {
		//hooks
		handleFetchAddress,
		handleSelectedState,
		handleOnSubmit,

		//useForm
		setValue,
		setFocus,
		register,
		handleSubmit,
		control,

		//Loading
		cepIsSubmitting,
		loading,
		loadingCities,

		//formState
		reset,
		errors,
		isSubmitting,

		citiesData,
		custumerAsaas,
		brazilStates,
	};
};
